import { render, staticRenderFns } from "./EditAffiliate.vue?vue&type=template&id=197f301a"
import script from "./EditAffiliate.vue?vue&type=script&lang=js"
export * from "./EditAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports